import { render, staticRenderFns } from "./picture-uploader.vue?vue&type=template&id=00962824&"
import script from "./picture-uploader.vue?vue&type=script&lang=js&"
export * from "./picture-uploader.vue?vue&type=script&lang=js&"
import style0 from "./picture-uploader.vue?vue&type=style&index=0&id=00962824&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports